"use strict";
var vibrant_1 = require("./vibrant");
var browser_1 = require("./image/browser");
vibrant_1.default.DefaultOpts.ImageClass = browser_1.default;
module.exports = vibrant_1.default;
//# sourceMappingURL=browser.js.map


//////////////////
// WEBPACK FOOTER
// ./~/node-vibrant/lib/browser.js
// module id = 585
// module chunks = 23899280101116